import { render, staticRenderFns } from "./SidebarSummary.vue?vue&type=template&id=29ced88b&scoped=true&"
import script from "./SidebarSummary.vue?vue&type=script&lang=js&"
export * from "./SidebarSummary.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSummary.vue?vue&type=style&index=0&id=29ced88b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ced88b",
  null
  
)

export default component.exports